<template>
  <div v-if="direction">
    <strong v-if="direction.title">{{ direction.title }}</strong>
    <div v-if="direction.type"><strong>Тип:</strong> {{ direction.type }}</div>
    <div v-if="direction.ege"><strong>ЕГЭ:</strong> {{ direction.ege }}</div>
    <div v-if="direction.benefit !== '-'">
      <strong>Доп. балл:</strong> {{ direction.benefit }}
    </div>
    <div v-if="direction.history.length">
      <ag-grid-vue
        class="ag-theme-material h-100"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :rowData="direction.history"
      />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import AgGridFactory from '@/components/helpers/factory/agGrid'

export default {
  name: 'DetailDirectionInfo',
  components: {
    AgGridVue
  },
  props: {
    direction: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      gridOptions: AgGridFactory.getGridOptionsDefault({
        defaultColDef: {
          sortable: true,
          filter: false,
          headerClass: 'p-1',
          cellClass: 'p-1',
          resizable: true
        },
        domLayout: 'autoHeight',
        pagination: false
      }),
      columnDefs: [
        {
          headerName: 'Год',
          field: 'year'
        },
        {
          headerName: 'Проход. балл',
          valueFormatter: (params) => params.value || '-',
          field: 'mark'
        },
        {
          headerName: 'Мест',
          valueFormatter: (params) => params.value || '-',
          field: 'quota'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
